module.exports = "/_next/static/images/PersonalizationAroundTheGlobe@2x-414c7013a6c0948f11dfacb581a3f1d0.webp";